import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './AlumniPage.scss';
import Header from '../../components/ActivePath/Header';

const AlumniPage: React.FC = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const notableAlumni = [
    {
      name: 'Manjunath N. S.',
      role: 'Salesforce Architect (Manager), Zscaler, USA',
      highlight: 'Global expert in cloud security with 15+ years of experience.',
    },
    {
      name: 'Ravi Panchksharappa (Batch 1986)',
      role: 'Civil Engineering – Quantity Surveyor',
      highlight: 'Contributing to infrastructure and urban development.',
    },
    {
      name: 'Zulfiqar Ali (Batch 1987)',
      role: 'Mechanical Engineering',
      highlight: 'Growth-oriented leader in core mechanical industries.',
    },
    {
      name: 'Rahul Ranjan (Batch ~2005)',
      role: 'Sales & Digital Marketing Strategist',
      highlight: 'Blending tech with digital growth strategies.',
    },
    {
        name: 'Gagan S Devang (Batch 2019)',
        role: 'Co-founder & Director, Prajnan Software Pvt. Ltd., Bengaluru',
        highlight: 'Self-made tech entrepreneur building impactful ventures with bold vision and real-world grit.'
      },      
      {
        name: 'Hemanth N. A. (Batch 2019)',
        role: 'Co-founder & Director, Prajnan Software Pvt. Ltd., Bengaluru',
        highlight: 'Tech co-founder driving innovation in the startup space.',
      },
  ];

  return (
    <div className="alumni-page">
      <Header pageTitle="" breadcrumb="Alumni" />

      <section className="intro" data-aos="fade-up">
        <h1>SJM Polytechnic Alumni Network</h1>
        <p>
          Welcome to the vibrant alumni community of SJM Polytechnic, Birur! Established in 1984, we take pride in our alumni excelling in diverse industries across the globe.
        </p>
      </section>

      <section className="notable-alumni" data-aos="fade-up">
        <h2>🌟 Notable Alumni & Achievements</h2>
        <div className="alumni-grid">
          {notableAlumni.map((alumnus, index) => (
            <div className="alumni-card" key={index}>
              <h3>{alumnus.name}</h3>
              <p><strong>{alumnus.role}</strong></p>
              <p>{alumnus.highlight}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="global" data-aos="fade-up">
        <h2>🌐 Alumni Across the Globe</h2>
        <p>
          Our alumni thrive at top MNCs, core engineering firms, government sectors, and as entrepreneurs—making a difference worldwide.
        </p>
      </section>

      <section className="connect" data-aos="fade-up">
        <h2>🤝 Connect | Engage | Contribute</h2>
        <ul>
          <li>🔗 Join our Facebook group: <strong>SJM Polytechnic Alumni – Birur</strong></li>
          <li>📧 Submit your profile to be featured in the Alumni Directory.</li>
          <li>🎓 Host guest talks, mentorships, or workshops.</li>
        </ul>
      </section>

      <section className="benefits" data-aos="fade-up">
        <h2>🏆 Alumni Benefits</h2>
        <ul>
          <li>🎯 Help with placements and referrals.</li>
          <li>🏫 Visit labs and attend alumni meets.</li>
          <li>📚 Access to learning and training sessions.</li>
        </ul>
      </section>

      <section className="contact" data-aos="fade-up">
        <h2>📬 Contact Us</h2>
        <p>Email: <strong>sjmpbirur1966@gmail.com</strong></p>
        <p>Phone: <strong>+91 78998 12669</strong></p>
      </section>
    </div>
  );
};

export default AlumniPage;
